export default __webpack_public_path__ + "static/media/temp_3.b66c2ca4.png";